import ky, { AfterResponseHook, BeforeRequestHook, Options } from "ky";
import { getCookie, signOut } from "../helpers/util";
import { ISODateString } from "../types/date";
import { getStoredNumber, storeNumber } from "../helpers/dateStored";
import { XSRFHeader, baseUrl, circuitUrl, fsReportUrl, schedulingUrl, smpwUrl } from "./const";

export type QueryDateRange = {
  fromDate?: ISODateString;
  toDate?: ISODateString;
};

export function circuitPath(path: string): string {
  return circuitUrl + path;
}

export function fsReportPath(path: string): string {
  return fsReportUrl + path;
}

export function schedulingPath(path: string): string {
  return schedulingUrl + path;
}

export function smpwPath(path: string): string {
  return smpwUrl + path;
}

const storageKey401 = "api401";

/** Signs the user out on a 401, unless we just did (to avoid a redirect loop). */
export function handleUnauthorized(response: Response): Response {
  if (response.status === 401) {
    const last401 = getStoredNumber(storageKey401);
    const nowTime = new Date().getTime();
    if (last401) {
      if (nowTime - last401 < 1000) {
        // if it's been less than 1 second since our last 401, just stop
        console.error("401 loop");
        return response;
      }
    }
    storeNumber(storageKey401, nowTime);
    signOut(false);
  }
  return response;
}

const afterResponse: AfterResponseHook[] = [(_, __, response) => handleUnauthorized(response)];

/** Headers every authenticated API request needs: the dev Basic auth (if configured) and the XSRF token. */
export function xsrfHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  if (import.meta.env.VITE_DEV_USER && import.meta.env.VITE_DEV_PASSWORD) {
    headers["Authorization"] = `Basic ${btoa(import.meta.env.VITE_DEV_USER + ":" + import.meta.env.VITE_DEV_PASSWORD)}`;
  }
  headers[XSRFHeader] = getCookie(XSRFHeader);
  return headers;
}

const beforeRequest: BeforeRequestHook[] = [
  (request) => {
    for (const [name, value] of Object.entries(xsrfHeaders())) {
      request.headers.set(name, value);
    }
    return request;
  },
];

const apiOptions: Options = {
  prefixUrl: baseUrl,
  timeout: 20 * 1000,
};

export const apiNoRedirect = ky.create({ ...apiOptions, hooks: { beforeRequest } });
export const api = ky.create({ ...apiOptions, hooks: { beforeRequest, afterResponse } });
